export default class RoutePlanner {
    nIntervId;
    sliderDropdownState;
    sliderParent;
    counter;

    constructor(el, nIntervId, sliderDropdownState, sliderParent, slider, counter) {
        this.el = el;
        this.nIntervId = nIntervId;
        this.sliderDropdownState = sliderDropdownState;
        this.sliderParent = sliderParent;
        this.counter = counter;
        this.init();
    }

    init() {
        this.getHtmlElements();
    }

    addHtmltoInputParent(parentDiv){    
        for (let i = 0; i < parentDiv.length; i++) {
            var parser = new DOMParser();
    
            var htmlstring2 = '<div class="c-input__right"> <div class="c-input-icon__container"> <i class="fa-solid fa-location-crosshairs"></i></div> </div>'
            var doc2 = parser.parseFromString(htmlstring2, "text/html");
            var element2 = doc2.body.firstChild;
            parentDiv[i].appendChild(element2);
        };
    }
    
    
    addHtmlToSliderParent(parentDiv) {
        var slider = parentDiv.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > div.routeYou_basicParameters > div.routeYou_inputBlock.routeYou_routeLengthSlider > div");
        this.counter = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > div.routeYou_basicParameters > div.routeYou_inputBlock.routeYou_routeLengthSlider > p > span");
        
        parentDiv.classList.add("c-slider__parent");
        parentDiv.innerHTML = `
            <div class='c-input slider'>
                <label class='c-input__label u-opacity-1' >Lengte</label>
                <div class='c-input__field c-slider__placeholder'>
                </div>
            </div>`;

        var labelDiv = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > div.routeYou_basicParameters > div.routeYou_inputBlock.routeYou_routeLengthSlider.c-slider__parent > div > div");
        labelDiv.append(this.counter);

        var c_input_field = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > div.routeYou_basicParameters > div.routeYou_inputBlock.routeYou_routeLengthSlider.c-slider__parent > div");
        c_input_field.addEventListener("click", () => this.handleSliderDropdownClick(slider))
    }
    
    handleSliderDropdownClick(slider) {
        this.sliderDropdownState = !this.sliderDropdownState;
        var test = document.createElement("div");
        test.classList.add("c-slider__container");
        test.appendChild(slider);

        if (this.sliderDropdownState) {
            this.sliderParent.appendChild(test);
        } else {
            this.closeSlider();
        }
    }

    handleLocationClick(e){
        document.querySelector(".routeYou_detectPosition>a").click();
    }

    closeSlider() {
        var toDelete = document.querySelector('#routeYouRouteViewerTabPane > div:nth-child(2) > div > div.routeYou_basicParameters > div.routeYou_inputBlock.routeYou_routeLengthSlider.c-slider__parent > div.c-slider__container');
        if (toDelete)
            toDelete.remove();
    }

    deleteElements(elements) {
        for (let i = 0; i < elements.length; i++) {
            elements[i].remove();
        }
    }

    handleClickAToB(btn) {
        var parent = btn.parentNode;
        var parent2 = parent.parentNode;
        var head = parent2.parentNode
        if(head.classList.contains("loop")){
            head.classList.remove("loop")
        }
        head.classList.add("AToB")
    }

    handleClickLoop(btn) {
        var parent = btn.parentNode;
        var parent2 = parent.parentNode;
        var head = parent2.parentNode;
        if(head.classList.contains("AToB")){
            head.classList.remove("AToB")
        }
        head.classList.add("loop")
    }

    handleClickDownloadTab(e){

        var dropDownParent = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div");

        var printDropdown = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > h3:nth-child(6)");
        var printDropdownContent = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > div:nth-child(7)");

        var downloadDropdown = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > h3:nth-child(8)");
        var downloadDropdownContent =document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > div:nth-child(9)");

        if(printDropdown && printDropdownContent && downloadDropdown && downloadDropdownContent){

            printDropdown.addEventListener("click", () => {
                var downloadDropdown = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > h3:nth-child(6)")
                if(downloadDropdown.classList.contains("routeYou_downloadSectionActive")){
                    downloadDropdown.classList.remove("routeYou_downloadSectionActive");
                    document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > div:nth-child(7)").style.height = "0px";
                }
            });
            downloadDropdown.addEventListener("click", () => {
                var printDropdown = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > h3:nth-child(8)");
                if(printDropdown.classList.contains("routeYou_downloadSectionActive")){
                    printDropdown.classList.remove("routeYou_downloadSectionActive");
                    document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > div:nth-child(9)").style.height = "0px";
                }
            });

            dropDownParent.removeChild(downloadDropdown);
            dropDownParent.removeChild(downloadDropdownContent);
    
            dropDownParent.insertBefore(downloadDropdown, printDropdown);
            dropDownParent.insertBefore(downloadDropdownContent, printDropdown);
        }
    }


    
    getHtmlElements() {
           
        var parentDiv = document.getElementsByClassName("routeYou_item");
        var inputs = document.getElementsByTagName('input');
        this.sliderParent = document.querySelector('#routeYouRouteViewerTabPane > div:nth-child(2) > div > div.routeYou_basicParameters > div.routeYou_inputBlock.routeYou_routeLengthSlider');

        if (parentDiv.length > 0) {
            this.addHtmltoInputParent(parentDiv);
        }

        if (this.sliderParent) {
            this.addHtmlToSliderParent(this.sliderParent);
        }

        var fromLabel = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > div.routeYou_basicParameters > div.routeYou_inputBlock.routeYou_routeBeginAddressSearch > p");
        if (fromLabel) {
            fromLabel.innerHTML = `<strong>Geef een startpunt in</strong> (of duid aan op de kaart)`
        }
        var toLabel = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > div.routeYou_basicParameters > div.routeYou_inputBlock.routeYou_routeEndAddressSearch > p");
        if (toLabel) {
            toLabel.innerHTML = `<strong>Geef een eindpunt in</strong> (of duid aan op de kaart)`
        }
        var startIcon = document.querySelector(".routeYou_beginIcon")
        if (startIcon) {
            startIcon.remove();
        }
        var endIcon = document.querySelector(".routeYou_endIcon")
        if (endIcon) {
            endIcon.remove();
        }
        var myLocationButtons = document.querySelectorAll(".c-input__right")
        if(myLocationButtons.length === 2){    
            myLocationButtons.forEach(element => {
                element.addEventListener("click", this.handleLocationClick)
            });
        }
        var AToB = document.querySelector("#routeYou_toggleRouteFromTo")
        if(AToB){
            AToB.addEventListener("click", () => this.handleClickAToB(AToB))
        }
        var loop = document.querySelector("#routeYou_toggleRouteRoundTrip")
        if(loop){
            loop.addEventListener("click", () => this.handleClickLoop(loop))
        }
        var headerText = document.querySelector(".c-header__text");
        headerText.addEventListener("click", this.handleHeaderClick);

        var downloadTab = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(1) > div > div > span:nth-child(2)");
        if(downloadTab){
            downloadTab.addEventListener("click", this.handleClickDownloadTab);
        }
    }

}
